import { motion } from "framer-motion";
import { Img } from "./Img";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] } }),
};

export const Gallery = () => {
  return (
    <section id="gallery" data-testid="gallery" className="relative bg-black py-24 sm:py-32 border-t border-neutral-900">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="mb-14 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
          <div>
            <p className="text-xs uppercase tracking-[0.35em] text-neon mb-5">The Kit</p>
            <h2 className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
              Signature <span className="font-script normal-case neon-text">Bala</span> gear
            </h2>
          </div>
          <p className="max-w-sm text-base text-neutral-400 font-light">
            Rings, bands and hand weights — every mat comes fully loaded so you can just show up and burn.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 grid-rows-2 gap-1 h-auto sm:h-[640px]">
          <motion.figure
            custom={0} variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true }}
            data-testid="gallery-ring"
            className="relative sm:col-span-2 sm:row-span-2 overflow-hidden border border-neutral-900 group aspect-[4/5] sm:aspect-auto"
          >
            <Img name="ring" alt="Pilates ring training in red light" sizes="(max-width: 640px) 100vw, 66vw" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            <figcaption className="absolute bottom-5 left-5 font-display uppercase text-3xl sm:text-4xl neon-text">Sculpting Ring</figcaption>
          </motion.figure>

          <motion.figure
            custom={1} variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true }}
            data-testid="gallery-bands"
            className="relative overflow-hidden border border-neutral-900 group aspect-square sm:aspect-auto"
          >
            <Img name="bands" alt="Bala resistance bands" sizes="(max-width: 640px) 100vw, 33vw" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            <figcaption className="absolute bottom-4 left-4 text-xs uppercase tracking-[0.2em] text-white/90">Resistance Bands</figcaption>
          </motion.figure>

          <motion.figure
            custom={2} variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true }}
            data-testid="gallery-weights"
            className="relative overflow-hidden border border-neutral-900 group aspect-square sm:aspect-auto"
          >
            <Img name="weights" alt="Bala hand weights" sizes="(max-width: 640px) 100vw, 33vw" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            <figcaption className="absolute bottom-4 left-4 text-xs uppercase tracking-[0.2em] text-white/90">Hand Weights</figcaption>
          </motion.figure>
        </div>
      </div>
    </section>
  );
};
